import {FieldPath} from 'react-hook-form';

import {prop, propOr} from 'ramda';

import i18n from '@dms/i18n';

import {BaseVehicle} from '../../core/types/BaseVehicle';
import {Field} from './primitives/Field';

type FieldMap = Partial<Record<FieldPath<BaseVehicle>, string>>;
type NumberFieldMap = Partial<Record<FieldPath<BaseVehicle>, number>>;

const getSimpleTextFieldsMap = (i18nInstance: typeof i18n) =>
  ({
    trim: i18nInstance.t('entity.vehicle.labels.trim'),
    variant: i18nInstance.t('entity.vehicle.labels.variantName'),
    manufacturerColorName: i18nInstance.t('entity.vehicle.labels.colorName'),
    manufacturerColorCode: i18nInstance.t('entity.vehicle.labels.manufacturerColorCode'),
    interiorColorName: i18nInstance.t('entity.vehicle.labels.interiorColorName'),
    engineName: i18nInstance.t('entity.vehicle.labels.engineName'),
    engineNumber: i18nInstance.t('entity.vehicle.labels.engineNumber'),
    engineCode: i18nInstance.t('entity.vehicle.labels.engineCode'),
    vehicleRegistrationNumber: i18nInstance.t('entity.vehicle.labels.vehicleRegistration'),
    registrationCertificateNumber: i18nInstance.t('entity.vehicle.labels.registrationCertificate'),
    hsn: i18nInstance.t('entity.vehicle.labels.hsn'),
    tsn: i18nInstance.t('entity.vehicle.labels.tsn'),
    modelRange: i18nInstance.t('entity.vehicle.labels.baureihe'),
    transmissionCode: i18nInstance.t('entity.vehicle.labels.transmissionCode'),
    transmissionNumber: i18nInstance.t('entity.vehicle.labels.transmissionNumber'),
  }) satisfies FieldMap;

const getMaxLengthsMap = () =>
  ({
    vehicleRegistrationNumber: 17,
    registrationCertificateNumber: 17,
    hsn: 4,
    tsn: 7,
    modelRange: 50,
  }) satisfies NumberFieldMap;

// const getSuffixesMap = (i18nInstance: typeof i18n) => ({
// } satisfies FieldMap);

interface SimpleTextFieldProps {
  name: keyof ReturnType<typeof getSimpleTextFieldsMap>;
}

export function SimpleTextField({name}: SimpleTextFieldProps) {
  const labels = getSimpleTextFieldsMap(i18n);
  const maxLengths = getMaxLengthsMap();
  // const suffixes = getSuffixesMap(i18n);

  return (
    <Field
      type="text"
      name={name}
      label={prop(name, labels)}
      maxLength={propOr(undefined, name, maxLengths)}
      // suffix={propOr(undefined, name, suffixes)}
    />
  );
}
